module.exports = __webpack_public_path__ + "static/media/injuredMinor.0d80610c.mp3";